// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"373":"__federation_expose_channel_multiplexer","789":"__federation_expose_dashboard_lite"}[chunkId] || chunkId) + "." + {"214":"1160aadf","373":"20254ba6","514":"1a264a76","517":"e02d1fcd","789":"1a0076d7","986":"9f31fb41"}[chunkId] + ".chunk.js";
};